import Slider from 'react-slick'


const Sliders = ({data}) => {
    const NextArrow = ({ onClick }) => (
        <div class="slick-custom is-next slick-arrow" onClick={onClick}><i class="fa fa-chevron-right"></i></div>
    )
    const PrevArrow = ({ onClick }) => (
        <div class="slick-custom is-prev slick-arrow" onClick={onClick}><i class="fa fa-chevron-left"></i></div>
    )
    const settings = {
        dots:false,
        infinite:true,
        speed: 500,
        slidesToShow:5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024, // For screens less than 1024px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600, // For screens less than 600px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            }
        ],
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    }
    return (
        <>
            <div className="related-products">
                <div className="related-products-inne">  
                    <Slider  {...settings}>
                        {data?.map((item, index) => (
                            <div className="related-product" >
                                <div className="related-product-price">
                                    <span>{item.price}</span>
                                </div>
                                <div class="related-product-image">
                                    <img src={item.featured} data-demo-src={item.featured} alt="test-demo" />
                                </div>
                                <div class="related-product-info">
                                    <h4>{item.category}</h4>
                                    <h3>{item.name}</h3>
                                </div>
                                <div class="buttons">
                                    <a class="button is-fullwidth" href="#">View</a>
                                </div>
                            </div>  
                        ))}
                    </Slider>
                </div>
            </div>
        </>
    )
}

export default Sliders